import React from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import ShowImageForAdmin from "../../../components/showImageForAdmin";

const ShowSavedProductDetail = ({
  productDetailTemp,
  setProductDetailTemp,
}) => {
  return (
    <>
      {productDetailTemp &&
        productDetailTemp.details.map((detail, i) => (
          <div key={i} className="border p-3 mb-3 mt-4">
            <h5>Saved Product {i + 1}</h5>

            <InputGroup className="my-2">
              <InputGroup.Text>Details</InputGroup.Text>

              <FormControl value={detail.color} readOnly />

              <FormControl value={`price: $${detail.price}`} readOnly />

              <FormControl value={`discount: $${detail.discount}`} readOnly />

              <FormControl value={`${detail.quantity} items`} readOnly />

              {/* Delete Button */}
              <Button
                variant="danger"
                className="btn-sm"
                onClick={() => {
                  const updatedDetails = [...productDetailTemp.details];
                  updatedDetails.splice(i, 1);
                  setProductDetailTemp({
                    ...productDetailTemp,
                    details: updatedDetails,
                  });
                }}
              >
                <i className="fas fa-trash" />
              </Button>
            </InputGroup>

            {/* Show Images */}
            <div
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              {detail.images.length > 0 && (
                <ShowImageForAdmin
                  source={detail.images} // Pass images array
                  handleRemoveImage={(index) => {
                    const updatedImages = [...detail.images];
                    updatedImages.splice(index, 1);
                    const updatedDetails = [...productDetailTemp.details];
                    updatedDetails[i].images = updatedImages;
                    setProductDetailTemp({
                      ...productDetailTemp,
                      details: updatedDetails,
                    });
                  }}
                />
              )}
            </div>
          </div>
        ))}
    </>
  );
};

export default ShowSavedProductDetail;
